import { call } from '@packages/functions';

// TODO: write unit tests

export const getValue = (
    value: any,
    prop: string | null = null,
    transformer: null | ((value: any, oldValue: any) => any) = null,
): any => {
    const value$ = value;

    if (value) {
        if (typeof value === 'object' && prop && value.hasOwnProperty(prop)) {
            value = value[prop];
        } else if (typeof value === 'object' && value.target) {
            if (prop && value.target.hasOwnProperty(prop)) {
                value = value.target[prop];
            } else {
                if (value.target.value) {
                    // Get value from an event
                    return getValue(value.target.value, prop, transformer);
                }
            }
        }
    }

    if (transformer && typeof transformer === 'function') {
        return call(transformer, value, value$);
    }

    return value;
};

/**
 * Get id from a given value
 * @param value
 * @returns {number|*}
 */
export const getValueId = (value: any): number => getValue(value, 'id', (value) => parseInt(value));
